export default "__VITE_ASSET__ad47b35c__"